module.exports = __webpack_public_path__ + "img/head-default-big.983060a3.jpg";